import React from "react";

import { IBrand } from "../../../../types/brands.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";
interface Props {
  brand: IBrand;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewBrandForm: React.FC<Props> = (props) => {
  return (
    <div>
      {props.brand.description && (
        <div className={styles.form}>
          <ViewInput
            title="Примітка"
            value={props.brand.description}
            isBig={true}
          />
        </div>
      )}
      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewBrandForm;
